<template>
    <v-simple-table dense>
        <tbody>
            <tr>
                <th>code</th>
                <td>{{ value ? value.code : null}}</td>
            </tr>
            <tr>
                <th>Name</th>
                <td>{{ value ? value.name : null}}</td>
            </tr>
            <tr>
                <th>Parent Group</th>
                <td>{{ value && value.parent ? value.parent.display_name : null }}</td>
            </tr>
        </tbody>
    </v-simple-table>
</template>

<script>
export default {
    name: "ItemGroup",
    props: {
        value: Object
    },
}
</script>

<style>

</style>